<template>
  <div class="userManagement">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">{{ $t('成员管理.成员管理') }}</span>
        <div class="head-text fr-mat-top-4">
          <el-input :placeholder="$t('成员管理.请输入用户姓名')" class="search-input" v-model="query"></el-input>
          <el-button slot="append" icon="el-icon-search" @click="cz" class="mar-t80"></el-button>
          <el-button type="primary" @click="addinvite">{{ $t('成员管理.邀请') }}</el-button>
          <el-button type="primary" @click="exportExcel">{{ $t('成员管理.导出') }}</el-button>
          <el-button type="danger" @click="deleteinfos">{{ $t('成员管理.移除') }}</el-button>
        </div>
      </div>
      <el-container>
        <!-- 这里是侧边栏-->
        <div class="mar-top20">
          <el-aside width="200px" class="elAside">
            <el-button type="primary" size="small" @click="showAll">{{ $t('成员管理.显示全部成员') }}</el-button>
            <zTree :zNodes="zNodes" @getData="getData2" @dropTree="dropTree" @addZtree="addZtree" @delZtree="delZtree"
              @EditName="EditName" :options="{
                id: 'prde01',
                pid: 'prde07',
                label: 'prde03',
                zTreeId: 'PdeptTree',
                delType: {
                  add: true,
                  update: true,
                  del: true,
                },
              }" ref="zTree" />
          </el-aside>
        </div>
        <el-main>
          <div class="rygl-table">
            <el-table align="center" class="margin-20 table width100" v-loading="loading" :data="inform" height="72vh"
              @selection-change="handleSelectionChange2">
              <el-table-column align="center" type="selection" width="55" :selectable="checkSelf"></el-table-column>
              <el-table-column align="center" prop="user02" :label="$t('成员管理.账号')"></el-table-column>
              <el-table-column align="center" prop="user04" :label="$t('成员管理.姓名')"></el-table-column>
              <el-table-column align="center" prop="user05" :label="$t('成员管理.性别')"></el-table-column>
              <el-table-column align="center" prop="prde03" :label="$t('成员管理.组织机构')"></el-table-column>
              <el-table-column align="center" prop="pror02" :label="$t('成员管理.岗位')"></el-table-column>
              <el-table-column align="center" prop="user12" :label="$t('成员管理.邮箱')"></el-table-column>
              <el-table-column align="center" prop="user11" :label="$t('成员管理.手机号')"></el-table-column>
              <el-table-column align="center" prop="comu05" :label="$t('成员管理.状态')">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.comu05 == 1 ? false : true" active-color="#13ce66"
                    inactive-color="#ff4949"></el-switch>
                </template>
              </el-table-column>
              <el-table-column align="center" :label="$t('成员管理.操作')" width="250">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" plain @click="editor(scope.row)">{{ $t('成员管理.查看')
                  }}</el-button>
                  <el-button size="small" type="primary" plain @click="UpdateProUserOpen(scope.row)">{{ $t('common.修改')
                  }}</el-button>
                  <el-button v-if="$store.state.isProject && scope.row.user01 != userID" size="small" type="danger"
                    plain @click="deleteinfo(scope.row)">{{ $t('成员管理.移除') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination class="mar-top20" align="center" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="pagenum" :page-sizes="[10, 50, 100]"
            :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </el-main>
      </el-container>

      <!-- 查看 -->
      <el-dialog :close-on-click-modal="false" :title="$t('成员管理.查看成员')" :visible.sync="editorDialogFormVisible1"
        width="50%" height="50%">
        <el-form :model="addForm" label-width="150px" ref="addForm">
          <el-form-item :label="$t('成员管理.账号')" prop="user02">
            <el-input :disabled="true" v-model="addForm.user02" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('成员管理.姓名')" prop="user04">
            <el-input :disabled="true" v-model="addForm.user04" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('成员管理.组织机构')" prop="prde03">
            <el-input :disabled="true" v-model="addForm.prde03" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('成员管理.邮箱')" prop="user12">
            <el-input :disabled="true" v-model="addForm.user12" auto-complete="off"></el-input>
          </el-form-item>

          <el-form-item :label="$t('成员管理.性别')" prop="user05">
            <el-input :disabled="true" v-model="addForm.user05" auto-complete="off"></el-input>
            <!-- <el-radio-group :disabled="true" v-model="addForm.user05">
              <el-radio-button label="男"></el-radio-button>
              <el-radio-button label="女"></el-radio-button>
            </el-radio-group> -->
          </el-form-item>
          <el-form-item :label="$t('成员管理.岗位')" prop="pror02">
            <el-input :disabled="true" v-model="addForm.pror02" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item :label="$t('成员管理.手机号')" prop="user11">
            <el-input :disabled="true" v-model="addForm.user11" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="updateList" v-if="btnShow">{{ $t('common.确定') }}</el-button>
        </div>
      </el-dialog>
      <!-- 邀请成员 -->
      <el-dialog :close-on-click-modal="false" :title="$t('成员管理.选择邀请账号信息')" :visible.sync="invitation" width="50%"
        height="50%">
        <el-form :model="invitationForm" label-width="80px" ref="addForm">
          <el-form-item>
            <el-row>
              <el-col :span="12">
                <el-table :data="multipleSelection">
                  <el-table-column align="center" :label="$t('成员管理.账号')" prop="Account"></el-table-column>
                  <el-table-column align="center" :label="$t('成员管理.姓名')" prop="Name"></el-table-column>
                  <el-table-column align="center" :label="$t('成员管理.操作')">
                    <template slot-scope="scope">
                      <el-button type="danger" @click="deleteUser(scope.$index)" plain size="small">{{ $t('common.删除')
                      }}</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('成员管理.组织机构')" label-width="150px" prop="user02">
                  <!-- <el-select filterable style="width:100%" v-model="organization" placeholder="请选择">
                    <el-option
                      v-for="item in organizationList"
                      :key="item.prde01"
                      :label="item.prde03"
                      :value="item.prde01"
                    ></el-option>
                  </el-select>-->
                  <el-cascader class="width100" @change="deptChange" :options="organizationList" :props="{
                    checkStrictly: true,
                    value: 'ID',
                    label: 'label',
                    children: 'children',
                  }" clearable></el-cascader>
                </el-form-item>
                <el-form-item :label="$t('成员管理.岗位')" label-width="150px" prop="user02">
                  <el-select filterable class="width100" v-model="value1" multiple>
                    <el-option v-for="item in options" :key="item.pror01" :label="item.pror02"
                      :value="item.pror01"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="18" :offset="5">
                <el-button @click="cityUserOpen" size="small" type="primary" plain>{{ $t('common.添加') }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="6" :offset="11">
            <el-button type="primary" @click="inviteBtn">{{ $t('common.确定') }}</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 企业人员列表 -->
      <el-dialog :close-on-click-modal="false" :title="$t('成员管理.选择邀请账号信息')" :visible.sync="cityUser" width="50%"
        height="50%">
        <div class="head-text mar00-20-30">
          <el-input :placeholder="$t('成员管理.请输入用户姓名')" class="search-input" v-model="query2"
            @input="query2Cx"></el-input>
          <el-button slot="append" icon="el-icon-search" @click="tongzhiList" class="mar-r80"></el-button>
        </div>
        <el-table ref="multipleTable" :data="cityUserList" tooltip-effect="dark" class="width100"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="Name" :label="$t('成员管理.姓名')" align="center"></el-table-column>
          <el-table-column prop="Sex" :label="$t('成员管理.性别')" align="center"></el-table-column>
          <el-table-column prop="Job" :label="$t('成员管理.岗位')" align="center"></el-table-column>
          <el-table-column prop="Address" :label="$t('成员管理.地址')" align="center"></el-table-column>
          <el-table-column prop="PhoneNumber" :label="$t('成员管理.手机号')" align="center"
            show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="txt-cen-pa20-0">
          <el-button @click="cityUser = false" type="primary">{{ $t('common.确定') }}</el-button>
        </div>
      </el-dialog>
      <!-- 编辑成员 -->
      <el-dialog :close-on-click-modal="false" :title="$t('成员管理.编辑成员')" :visible.sync="UpdateProUserOpen1" width="40%"
        height="50%" id="UpdateProUserOpen1">
        <!-- <el-card class="box-card"> -->
        <el-row>
          <el-col :span="12">
            {{ $t('成员管理.请选择组织') }}:
            <!-- <el-select filterable style="width:100%" v-model="organization" placeholder="请选择">
              <el-option
                v-for="item in organizationList"
                :key="item.prde01"
                :label="item.prde03"
                :value="item.prde01"
              ></el-option>
            </el-select>-->
            <template>
              <el-cascader class="width90" @change="deptChange" :options="organizationList" :props="{
                checkStrictly: true,
                value: 'ID',
                label: 'label',
                children: 'children',
              }" clearable :placeholder="deptName"></el-cascader>
            </template>
          </el-col>
          <el-col :span="12">
            {{ $t('成员管理.请选择岗位') }}:
            <el-select filterable class="width100" @click.native="clearOut" v-model="value1" multiple
              :placeholder="jobName">
              <el-option v-for="item in options" :key="item.pror01" :label="item.pror02"
                :value="item.pror01"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :offset="9" class="text-cen">
            <el-button type="primary" @click="UpdateProUser">{{ $t('common.确定') }}</el-button>
          </el-col>
        </el-row>
        <!-- </el-card> -->
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import zTree from "@/components/zTree";
import {
  GetMember,
  RemoveMember,
  UpdateMember,
  GetCompanyUserList,
  GetProjectRole,
  GetteamOrganization,
  AddProjectUser,
  FindProUser,
  GetteamOrganizationList,
  UpdateProUser,
  GetProjectdeptZTree,
  Addteam,
  EditProdept,
  DelProdept,
  GetTeam,
  ChangeProjectDeptOrder,
} from "@/setAxios.js";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { format } from "path";
export default {
  name: "userManagement",
  data() {
    return {
      userID: localStorage.getItem("id"),
      UpdateProUserOpen1: false,
      query: "",
      // 邀请用户搜索
      query2: "",
      loading: false,
      total: 0,
      pagesize: 10,
      pagenum: 1,
      addDialogFormVisible: false,
      editorDialogFormVisible1: false,
      invitation: false,
      cityUser: false,
      inform: [],
      addForm: {},
      addForm1: {},
      organization: "",
      jobs: "",
      organizationList: [],
      invitationForm: {},
      props: { multiple: true, checkStrictly: true },
      options: [],
      value1: [],
      cityUserList: [],
      multipleSelection: [],
      multipleSelection2: [],
      btnShow: true,
      projectrole: [],
      ids: "null",
      zNodes: null,
      selectNode: null,
      zTeeObj: null,
      deptName: "",
      jobName: "",
    };
  },
  components: { zTree },
  methods: {
    checkSelf(row) {
      return this.$store.state.isProject && row.user01 != this.userID;
    },
    // 传的方法
    getData2(ids) {
      this.loading = true;
      let params = {
        seachword: this.query,
        id: localStorage.getItem("xid"),
        cid: localStorage.getItem("pid"),
        bid: ids,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetMember({ params }).then((res) => {
        this.loading = false;
        this.inform = res.Data.list;
        this.total = res.Data.total;
      });
    },
    dropTree(data) {
      ChangeProjectDeptOrder(data);
      this.$message({
        type: "success",
        message: this.$t('common.处理成功')
      });
    },
    async addZtree(id) {
      let params = {
        prde01: 0,
        prde02: localStorage.getItem("xid"),
        prde03: this.$t('common.新建节点'),
        prde05: localStorage.getItem("id"),
        prde06: new Date(),
        prde07: id,
      };
      let res = await Addteam({ prodept: JSON.stringify(params) });
      this.$refs.zTree.add(res);
    },
    async delZtree(ids) {
      let params = { xid: localStorage.getItem("xid"), bid: ids };
      let res = await DelProdept(params);
      this.$refs.zTree.del(res);
    },
    async EditName(id, name) {
      let params = {
        id,
        name,
      };
      let res = await EditProdept(params);
      this.$message.success(this.$t('common.处理成功'));
    },

    GetProjectdeptZTree() {
      this.loading = true;
      let params = {
        id: localStorage.getItem("xid"),
      };
      GetProjectdeptZTree({ params }).then((res) => {
        this.zNodes = res.Data;

        // this.$refs.zTree.init(this.zNodes);
        // this.init();
        this.loading = false;
        // this.getData();
      });
    },
    query2Cx(i) {
      let params = {
        seachword: i,
        xid: localStorage.getItem("xid"),
        qid: localStorage.getItem("pid"),
      };
      GetCompanyUserList({ params }).then((res) => {
        this.cityUserList = res.Data;
        //(res, "未已参与项目公司内人员列表");
      });
    },
    clearOut() {
      this.value1 = "";
    },
    deptChange(val) {
      this.organization = val[val.length - 1];
    },
    // 确定编辑
    UpdateProUser() {
      let list = [];
      this.projectrole.prou06 = this.organization;
      if (this.value1) {
        this.value1.forEach((ele) => {
          var a = {};
          a.pror01 = ele;
          list.push(a);
        });
      }
      let params = {
        list,
        user: this.projectrole,
      };
      UpdateProUser(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: this.$t('common.处理成功'),
          });
          this.UpdateProUserOpen1 = false;
          this.getData();
        }
      });
    },
    // 成员编辑
    UpdateProUserOpen(row) {
      this.deptName = row.prde03;
      this.jobName = row.pror02;
      this.UpdateProUserOpen1 = true;
      var params = {
        xid: localStorage.xid,
        uid: row.user01,
      };
      FindProUser(params).then((res) => {
        this.projectrole = res.Data;
        this.organization = res.Data.prou06;
      });
      this.organization = "";
      this.value1 = "";
      let xid = parseInt(localStorage.getItem("xid"));
      GetProjectRole({ xid }).then((res) => {
        this.options = res.Data;
      });
      var params = {
        id: localStorage.getItem("xid"),
      };
      GetTeam({ params }).then((res) => {
        this.removeNull(res.Data);
        this.organizationList = res.Data;
      });
    },
    removeNull(arr) {
      arr.forEach((ele) => {
        if (ele.children == undefined)
          return
        if (ele.children.length == 0) {
          delete ele.children;
        } else {
          this.removeNull(ele.children);
        }
      });
    },
    // 邀请
    addinvite() {
      this.organization = "";
      this.value1 = "";
      this.invitation = true;
      let xid = localStorage.getItem("xid");
      GetProjectRole({ xid }).then((res) => {
        this.options = res.Data;
      });
      let params = {
        id: localStorage.getItem("xid"),
      };
      GetteamOrganization({ params }).then((res) => {
        this.removeNull(res.Data);
        this.organizationList = res.Data;
      });
    },
    // 邀请确定键
    inviteBtn() {
      let lists = [];
      if (
        this.organization &&
        this.value1 &&
        this.multipleSelection.length > 0
      ) {
        this.multipleSelection.map((i, index) => {
          lists.push(i.id);
        });
        let uids = lists.join(",");
        let bid = this.organization;
        let xid = localStorage.getItem("xid");
        let rids = this.value1.join(",");
        AddProjectUser({ uids, bid, xid, rids }).then((res) => {
          //(res);
          if (res.Code === 1) {
            this.$message({
              type: "success",
              message: this.$t('common.处理成功'),
            });
            this.invitation = false;
            this.getData();
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: this.$t('common.请输入内容'),
        });
      }
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
      //(this.multipleSelection);
    },
    cityUserOpen() {
      this.cityUser = true;
      let params = {
        seachword: "",
        xid: localStorage.getItem("xid"),
        qid: localStorage.getItem("pid"),
      };
      GetCompanyUserList({ params }).then((res) => {
        this.cityUserList = res.Data;
        //(res, "未已参与项目公司内人员列表");
      });
    },
    deleteUser(index) {
      //(index);

      this.multipleSelection.splice(index, index + 1);
      this.$message({
        type: "success",
        message: this.$t('common.处理成功')
      });
    },
    // 岗位多选
    jobchange(data) {
      //(data);
    },
    // 导出表格所用
    exportExcel() {
      // 设置当前日期
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let name = year + "" + month + "" + day;
      // //(name)
      /* generate workbook object from table */
      //  .table要导出的是哪一个表格
      var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        //  name+'.xlsx'表示导出的excel表格名字
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        // if (typeof console !== "undefined") //(e, wbout);
      }
      return wbout;
    },
    // 这里是获取通知列表
    tongzhiList() { },
    //批量删除
    deleteinfos() {
      if (this.multipleSelection2.length == 0) {
        this.$message({
          type: "warning",
          message: this.$t('common.请先选择'),
        });
      } else {
        this.$confirm(this.$t('common.删除询问'), this.$t('common.提示'), {
          confirmButtonText: this.$t('common.确定'),
          cancelButtonText: this.$t('common.取消'),
          type: "warning",
        })
          .then(() => {
            let users = "",
              _split = "";
            this.multipleSelection2.forEach((v) => {
              users += _split + v.user01;
              _split = ",";
            });
            let params = {
              uid: users,
              xid: localStorage.getItem("xid"),
            };
            RemoveMember(params).then((res) => {
              //(res);
              if (res.Code === 1) {
                this.$message({
                  type: "success",
                  message: this.$t('common.处理成功')
                });
              }
              this.getData();
            });
          })
      }
    },
    //   删除
    deleteinfo(row) {
      //(row);
      this.$confirm(this.$t('common.删除询问'), "提示", {
        confirmButtonText: this.$t('common.确定'),
        cancelButtonText: this.$t('common.取消'),
        type: "warning",
      })
        .then(() => {
          let params = {
            uid: row.user01,
            xid: localStorage.getItem("xid"),
          };
          RemoveMember(params).then((res) => {
            //(res);
            if (res.Code === 1) {
              this.$message({
                type: "success",
                message: this.$t('common.处理成功')
              });
            }
            this.getData();
          });
        })
    },
    //   编辑
    editor(row) {
      this.editorDialogFormVisible1 = true;
      this.addForm = row;
    },
    // 编辑确定按钮
    updateList() {
      this.editorDialogFormVisible1 = false;
      // //(this.addForm);
      // let parmas = JSON.stringify(this.addForm);
      // UpdateMember({ comuser: parmas }).then(res => {
      //   //(res);
      //   this.editorDialogFormVisible1 = false;
      //   this.getDate();
      // });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      //(val);
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getData();
    },
    showAll() {
      this.loading = true;
      let params = {
        seachword: "",
        id: localStorage.getItem("xid"),
        cid: localStorage.getItem("pid"),
        bid: "null",
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetMember({ params }).then((res) => {
        this.loading = false;
        this.inform = res.Data.list;
        this.total = res.Data.total;
      });
    },
    getData() {
      this.loading = true;
      let params = {
        seachword: this.query,
        id: localStorage.getItem("xid"),
        cid: localStorage.getItem("pid"),
        bid: this.ids,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetMember({ params }).then((res) => {
        //(res);
        this.loading = false;
        this.inform = res.Data.list;
        this.total = res.Data.total;
      });
    },
    //查找
    cz() {
      this.loading = true;
      let params = {
        seachword: this.query,
        id: localStorage.getItem("xid"),
        cid: localStorage.getItem("pid"),
        bid: this.ids,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetMember({ params }).then((res) => {
        //(res);
        this.loading = false;
        this.inform = res.Data.list;
        this.total = res.Data.total;
      });
    },
  },
  created() {
    // this.getData();
  },
  mounted() {
    this.GetProjectdeptZTree();
  },
};
</script>

<style lang="less" scoped>
div#PdeptRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#PdeptRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#PdeptRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#PdeptRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

#PdeptTree {
  height: 500px;
}

.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  // color: #fff;
  line-height: 21px;
  margin-right: 2px;
}

.userManagement .search-input {
  width: 300px;
}

/deep/ #UpdateProUserOpen1 .el-input__inner::-webkit-input-placeholder {
  color: #000000;
}
</style>
<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}

.fr-mat-top-4 {
  float: right;
  margin-top: -4px;
}

.mar-t80 {
  margin-right: 80px;
}

.mar-top20 {
  margin-top: 20px;
}

.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}

.width100 {
  width: 100%;
}

.mar-top40 {
  margin-top: 40px;
}

.mar00-20-30 {
  margin: 0 0 20px 30%;
}

.mar-r80 {
  margin-right: 80px;
}

.txt-cen-pa20-0 {
  text-align: center;
  padding: 20px 0;
}

.width90 {
  width: 90%;
}

.text-cen {
  text-align: center;
}
</style>
